import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import {Typography} from 'src/styles';
import {useNavigation} from '@react-navigation/core';
import SVG from 'src/styles/svg';
import {useStyle} from 'src/providers/style';
import {useSelector} from 'react-redux';
import moment from 'moment';
interface HomeNotesProps {
  notesDue: number;
  inProgress: number;
  completed: number;
  notStarted: number;
}
const HomeNotes = ({
  notesDue,
  inProgress,
  completed,
  notStarted,
}: HomeNotesProps) => {
  const navigation = useNavigation();
  const styles = useStyle();
  const {userId} = useSelector(state => state.authentication);

  const navigateWithStatus = (status: string) => {
    navigation.navigate('UserProfile', {
      practitionerId: userId,
      screen: 'History',
      status,
    });
  };

  const formattedPreviousMonthDate = moment()
    .subtract(1, 'months')
    .format('MMMM Do, YYYY');

  return (
    <View
      style={[
        styles.width,
        styles.backgroundColorWhite,
        styles.paddingHorizontal,
        styles.paddingLVertical,
        styles.borderRadius,
        styles.elevation,
      ]}>
      <View style={[styles.paddingMBottom]}>
        <Text style={[Typography.P4]}>
          Session Progress since {formattedPreviousMonthDate}
        </Text>
      </View>

      <View style={[styles.tabletLContainer, styles.justifySpaceBetween]}>
        {/* Not started */}
        <TouchableOpacity onPress={() => navigateWithStatus('not-started')}>
          <View style={[styles.row, styles.alignCenter]}>
            <SVG height={36} name={'timer_off'} />
            <View style={[styles.marginLLeft, styles.marginSMTop]}>
              <Text style={[Typography.H4]}>{notStarted}</Text>
              <Text
                style={[
                  Typography.P4,
                  styles.textColorPrimary,
                  styles.positionRelative,
                ]}>
                Not Started
              </Text>
            </View>
          </View>
        </TouchableOpacity>

        {/* In progress */}
        <TouchableOpacity onPress={() => navigateWithStatus('in-progress')}>
          <View style={[styles.row, styles.alignCenter]}>
            <SVG height={36} name={'timer_sand'} />
            <View style={[styles.marginLLeft, styles.marginSMTop]}>
              <Text style={[Typography.H4]}>{inProgress}</Text>
              <Text
                style={[
                  Typography.P4,
                  styles.textColorPrimary,
                  styles.positionRelative,
                ]}>
                In Progress
              </Text>
            </View>
          </View>
        </TouchableOpacity>

        {/* Notes due */}
        <TouchableOpacity onPress={() => navigateWithStatus('missing-values')}>
          <View style={[styles.row, styles.alignCenter]}>
            <SVG height={36} name={'note'} />
            <View style={[styles.marginLLeft, styles.marginSMTop]}>
              <Text style={[Typography.H4]}>{notesDue}</Text>
              <Text
                style={[
                  Typography.P4,
                  styles.textColorPrimary,
                  styles.positionRelative,
                ]}>
                Missing Values
              </Text>
            </View>
          </View>
        </TouchableOpacity>

        {/* Completed */}
        <TouchableOpacity onPress={() => navigateWithStatus('completed')}>
          <View style={[styles.row, styles.alignCenter]}>
            <SVG height={36} name={'clipboard_check'} />
            <View style={[styles.marginLLeft, styles.marginSMTop]}>
              <Text style={[Typography.H4]}>{completed}</Text>
              <Text
                style={[
                  Typography.P4,
                  styles.textColorPrimary,
                  styles.positionRelative,
                ]}>
                Completed
              </Text>
            </View>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default HomeNotes;
